import React, { useState } from 'react';
import './LoginPage.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';


const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const navigate = useNavigate();

  function createRipple(event) {
    const button = event.currentTarget;
    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
  
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.getBoundingClientRect().left - radius}px`;
    circle.style.top = `${event.clientY - button.getBoundingClientRect().top - radius}px`;
    circle.classList.add("ripple");
  
    // Удаляем старую рябь, если есть
    const existingRipple = button.getElementsByClassName("ripple")[0];
    if (existingRipple) {
      existingRipple.remove();
    }
  
    button.appendChild(circle);
  }



  return (
    <div className="login-wrapper">
      <div className="login-box">
        <h2>Вход</h2>

        <div className={`input-block ${emailFocused ? 'focused' : ''}`}>
          <input
            type="text"
            required
            onFocus={() => setEmailFocused(true)}
            onBlur={(e) => setEmailFocused(e.target.value !== '')}
          />
          <label>Почта</label>
        </div>

        <div className={`input-block ${passwordFocused ? 'focused' : ''}`}>
          <input
            type={showPassword ? 'text' : 'password'}
            required
            onFocus={() => setPasswordFocused(true)}
            onBlur={(e) => setPasswordFocused(e.target.value !== '')}
          />
          <label>Пароль</label>
          <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <button
          className="login-button"
          onMouseDown={createRipple}
          onClick={() => navigate('/collectors')}
        >
          Войти
        </button>

        <Link className="login-subtext" to="/register">
          Регистрация
        </Link>
      </div>
    </div>
  );
};

export default LoginPage;
